import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import LanguageContext from "./Context/LanguageContext";

// Global handler to suppress "Unknown promise rejection" overlay
window.addEventListener(
  "unhandledrejection",
  (event) => {
    const reason = event.reason;
    const isUnknown =
      reason === "Unknown promise rejection reason" ||
      (reason &&
        typeof reason === "object" &&
        reason.message === "Unknown promise rejection reason");

    // Check for undefined/null reason or the specific unknown message
    if (reason === undefined || reason === null || isUnknown) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
  },
  true // Use capture phase to intercept before React
);

// Global handler to suppress "ResizeObserver loop" error overlay
window.addEventListener(
  "error",
  (event) => {
    if (
      event.message === "ResizeObserver loop limit exceeded" ||
      event.message ===
      "ResizeObserver loop completed with undelivered notifications."
    ) {
      event.stopImmediatePropagation();
      return;
    }
  },
  true
);

// Suppress specific errors from showing in the React Error Overlay
const originalConsoleError = console.error;
console.error = (...args) => {
  if (
    typeof args[0] === "string" &&
    (args[0].includes("Unknown promise rejection reason") ||
      args[0].includes("Unhandled Rejection") ||
      args[0].includes("ResizeObserver loop"))
  ) {
    return;
  }
  originalConsoleError(...args);
};

ReactDOM.render(
  <LanguageContext>
    <Router>
      <App />
    </Router>
  </LanguageContext>,
  document.getElementById("root")
);

serviceWorker.unregister();
